import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCurrentException } from '@/redux/selectors/exceptionDrawerSelectors';
import { getData } from '@/redux/slices/dataTableSlice';
import { getCurrentException } from '@/redux/slices/exceptionDrawerSlice';

export const useRefreshActiveException = () => {
  const dispatch = useAppDispatch();
  const activeException = useAppSelector(selectCurrentException);

  const refreshActiveExceptions = useCallback(() => {
    if (activeException?.id) {
      dispatch(getCurrentException(activeException?.id));
    }
  }, [activeException]);

  return refreshActiveExceptions;
};

/**
 * This hook reloads both the Exceptions table and the exception opened in the drawer (if opened).
 */
export const useRefreshExceptions = () => {
  const dispatch = useAppDispatch();
  const refreshActiveException = useRefreshActiveException();

  const refreshExceptions = useCallback(() => {
    dispatch(getData());
    refreshActiveException();
  }, [refreshActiveException]);

  return refreshExceptions;
};
